export const CONTACT_ENDPOINT = '/api/contact';
